/* Release 3.5.136 — mobile description control and sold-out quantity guard. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('.et-mobile-description').forEach((description) => {
      const button = description.querySelector('.et-mobile-description__toggle');
      if (!button || button.dataset.etReady === 'true') return;
      button.dataset.etReady = 'true';
      description.classList.add('et-description-ready');
      button.addEventListener('click', () => {
        const expanded = description.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.querySelector('span:first-child').textContent = expanded ? 'Close description' : 'Read full description';
        button.querySelector('span:last-child').textContent = expanded ? '−' : '+';
      });
    });
    root.querySelectorAll('quantity-input').forEach((quantity) => {
      const input = quantity.querySelector('input[type="number"]');
      const plus = quantity.querySelector('button[name="plus"]');
      if (!input || !plus) return;
      const sync = () => {
        const max = Number(input.max);
        const unavailable = input.closest('.product-form__quantity')?.classList.contains('hidden') || max === 0;
        if (unavailable) {
          input.value = 0;
          plus.disabled = true;
          plus.setAttribute('aria-disabled', 'true');
        }
      };
      sync(); input.addEventListener('change', sync);
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
